import script from "./delivery-service-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./delivery-service-list.vue?vue&type=script&lang=ts&setup=true"

import "./delivery-service-list.vue?vue&type=style&index=0&id=ff63c5fc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff63c5fc"]])

export default __exports__